function componentsRepositionWidgets() {
  // reposition Instagram
  repositionInstagram();

  // add newsletter form only for chosen destinations
  // for wsk / whu / wcz / wro we use mailocator form
  if (shopName === 'dpc' || shopName === 'eag') {
    repositionNewsletter();
  }
}

var widgetInstagram;
function repositionInstagram() {
  if ($(".instagram-widget").length) {
    if ($(".in-index").length || $(".type-detail").length) {
      createInstagramBlock();
      $(".custom-footer__instagram, .instagram-block").addClass("is-active");
    } else {
      $(".instagram-widget").closest("div").parent().remove();
    }
  }
}

function createInstagramBlock() {
  var instagramBlock = $(".instagram-widget");
  var instagramContainer = `
		<div class="content-wrapper instagram-block js-instagram-block">
			<div class="container">
				<div class="row">
					<div class="col-xs-12">
					</div>
				</div>
			</div>
		</div>
	`;

  $(".instagram-widget").closest("div").parent().remove();
  $(instagramContainer).insertBefore("#footer");
  $(".js-instagram-block .col-xs-12").append(instagramBlock);

  $(".js-instagram-block .instagram-widget > a").wrap(
    '<div class="instagram-widget-item"></div>'
  );
}

function repositionNewsletter() {
  var nlSignupActionTerm;
  var nlSignupIdTerm;
  var nlHeadText;
  var nlHeadDescription;
  var nlConfirmationButton;
  var nlMessageNotification;
  var nlEmailValidation;
  var nlEmailAdressText;
  var nlWebFormFieldId;
  var nlArticleUrl;
  var nlMessage;

  switch(lang) {
    case 'sk':
      nlHeadText = 'Získajte úžasné nápady pre vyladenie vášho domova.';
      nlHeadDescription = 'Priatelia, prihláste sa na odber noviniek a každý týždeň získajte skvelé tipy či informácie o produktoch a zľavách.';
      nlConfirmationButton = 'Potvrdiť';
      nlMessageNotification = 'Je potrebné potvrdiť, že máte viac ako 16 rokov a udeliť spoločnosti Wilsondo s.r.o. súhlas so spracovaním osobných údajov.';
      nlEmailValidation = 'Prosím vložte platnú e-mailovú adresu.';
      nlEmailAdressText = 'Váš e-mail:';
      nlWebFormFieldId = '64';
      nlArticleUrl = 'in-odber-noviniek';
      break;
    case 'hu':
      nlHeadText = 'Szuper ötleteket adunk, hogy milyen új bútordarabokkal dobd fel az otthonod.';
      nlHeadDescription = 'Iratkozz fel a hírlevelünkre és minden héten értesülhetsz az újdonságainkról, ajánlásainkról és akcióinkról.';
      nlConfirmationButton = 'Megerősítés';
      nlMessageNotification = 'Meg kell erősítenie, hogy már elmúlt 16 éves, és beleegyezését adja, hogy a Wilsondo s.r.o. vállalat feldolgozhassa a személyes adatait.';
      nlEmailValidation = 'Kérem, adjon meg egy érvényes e-mail címet.';
      nlEmailAdressText = 'E-mail:';
      nlWebFormFieldId = '67';
      nlArticleUrl = 'in-feliratkozas-hirlevelre';
      break;
    case 'cs':
      nlHeadText = 'Získejte úžasné nápady pro vyladění vašeho domova.';
      nlHeadDescription = 'Přátelé, přihlaste se k odběru novinek a každý týden získejte skvělé tipy či informace o produktech a slevách.';
      nlConfirmationButton = 'Potvrdit';
      nlMessageNotification = 'Je potřeba potvrdit, že vám je více než 16 let a udělit společnosti Wilsondo s.r.o. souhlas se zpracováním osobních údajů.';
      nlEmailValidation = 'Prosím vložte platnou e-mailovou adresu.';
      nlEmailAdressText = 'Váš e-mail:';
      nlWebFormFieldId = '70';
      nlArticleUrl = 'in-odber-novinek';
      break;
    case 'ro':
      nlHeadText = 'Obțineți idei uimitoare pentru a vă îmbunătăți casa.';
      nlHeadDescription = 'Dragilor, înscrieți-vă la newsletterul nostru și primiți sfaturi excelente sau informații despre produse și reduceri în fiecare săptămână.';
      nlConfirmationButton = 'Confirmați';
      nlMessageNotification = 'Este necesar să confirmați că aveți peste 16 ani și să acordați companiei Wilsondo s.r.o. consimțământul pentru prelucrarea datelor cu caracter personal.';
      nlEmailValidation = 'Vă rugăm să introduceți o adresă de email validă.';
      nlEmailAdressText = 'E-mailul dumneavoastră:';
      nlWebFormFieldId = '73';
      nlArticleUrl = 'in-abonati-va-la-newsletter';
      break;
    case 'bg':
      nlHeadText = 'Získajte úžasné nápady pre vyladenie vášho domova.';
      nlHeadDescription = 'Priatelia, prihláste sa na odber noviniek a každý týždeň získajte skvelé tipy či informácie o produktoch a zľavách.';
      nlConfirmationButton = 'Potvrdiť';
      nlMessageNotification = 'Je potrebné potvrdiť, že máte viac ako 16 rokov a udeliť spoločnosti Wilsondo s.r.o. súhlas so spracovaním osobných údajov.';
      nlEmailValidation = 'Prosím vložte platnú e-mailovú adresu.';
      nlEmailAdressText = 'Váš e-mail:';
      nlWebFormFieldId = '64';
      nlArticleUrl = 'in-odber-noviniek';
      break;
    case 'hr':
      nlHeadText = 'Pronađite nevjerojatne ideje za uređenje vašeg doma.';
      nlHeadDescription = 'Prijatelji, pretplatite se na novosti i svaki tjedan primajte sjajne savjete ili informacije o proizvodima i popustima.';
      nlConfirmationButton = 'Potvrditi';
      nlMessageNotification = 'Potrebno je potvrditi da imate više od 16 godina i tvrtki Wilsondo d.o.o. dati suglasnost za obradu osobnih podataka.';
      nlEmailValidation = 'Molimo unesite važeću adresu e-pošte.';
      nlEmailAdressText = 'Vaša e-pošta:';
      nlWebFormFieldId = '64'; //TODO HR/SI
      nlArticleUrl = 'in-pretplata-na-novosti';
      break;
    case 'si':
      nlHeadText = 'Poiščite čudovite ideje za izboljšanje svojega doma.';
      nlHeadDescription = 'Prijatelji, prijavite se na naše e-novice in vsak teden prejmite odlične nasvete ali informacije o izdelkih in popustih.';
      nlConfirmationButton = 'Potrditi';
      nlMessageNotification = 'Morate potrditi, da ste starejši od 16 let, in družbi Wilsondo s.r.o. dati soglasje za obdelavo vaših osebnih podatkov.';
      nlEmailValidation = 'Vnesite veljaven e-poštni naslov.';
      nlEmailAdressText = 'Vaš e-poštni naslov:';
      nlWebFormFieldId = '64'; //TODO HR/SI
      nlArticleUrl = 'in-narocnina-na-e-novice';
      break;
    case 'ua':
      nlHeadText = 'Získajte úžasné nápady pre vyladenie vášho domova.';
      nlHeadDescription = 'Priatelia, prihláste sa na odber noviniek a každý týždeň získajte skvelé tipy či informácie o produktoch a zľavách.';
      nlConfirmationButton = 'Potvrdiť';
      nlMessageNotification = 'Je potrebné potvrdiť, že máte viac ako 16 rokov a udeliť spoločnosti Wilsondo s.r.o. súhlas so spracovaním osobných údajov.';
      nlEmailValidation = 'Prosím vložte platnú e-mailovú adresu.';
      nlEmailAdressText = 'Váš e-mail:';
      nlWebFormFieldId = '64';
      nlArticleUrl = 'in-odber-noviniek';
      break;
    default:
    return;
  }
  switch(shopName) {
    case 'wsk':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlSignupIdTerm = 'se20-webform-149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlMessage = 'Súhlasím s <a href="/uzitocne-informacie/podmienky-ochrany-osobnych-udajov/" target="_blank">podmienkami ochrany osobných údajov</a>&nbsp;a zároveň potvrdzujem, že mám viac ako 16 rokov.';
      break;
    case 'whu':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-kcu3srl3u1es7ctrwkl29am1u91d2gxtokg8ukivew285gzzap73xjerv6x8xquxoiwm6or4bg65u3c5ovebrdgj9npshahgqltq';
      nlSignupIdTerm = 'se20-webform-149206-kcu3srl3u1es7ctrwkl29am1u91d2gxtokg8ukivew285gzzap73xjerv6x8xquxoiwm6or4bg65u3c5ovebrdgj9npshahgqltq';
      nlMessage = 'Elfogadom <a href="/hasznos-tudnivalok/informaciok-a-szemelyes-adatok-kezeleserol-gdpr/" target="_blank">az adatvédelmi szabályzat feltételeit</a>,&nbsp;és egyben megerősítem, hogy elmúltam 16 éves.';
      break;
    case 'wcz':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-fhn409vjzsgkxvyzxr56e2uwoc028h394rjewnq5za7qtanmyg7bmp0qys6x41ah2u7qsfhjc95z407ain5ap0b6k3hrkx6xraii';
      nlSignupIdTerm = 'se20-webform-149206-fhn409vjzsgkxvyzxr56e2uwoc028h394rjewnq5za7qtanmyg7bmp0qys6x41ah2u7qsfhjc95z407ain5ap0b6k3hrkx6xraii';
      nlMessage = 'Souhlasím s <a href="/podminky-ochrany-osobnich-udaju/" target="_blank">podmínkami ochrany osobních údajů</a>&nbsp;a zároveň potvrzuji, že mi je více než 16 let.';
      break;
    case 'wro':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-bbifhc10ra5kzazwf7x4qyfokbbxwrs9xw4nc41lvchuzckqadbzj9exj4obigao2detnr899m2nyjo8j2968ak67qlb25y0kee8';
      nlSignupIdTerm = 'se20-webform-149206-bbifhc10ra5kzazwf7x4qyfokbbxwrs9xw4nc41lvchuzckqadbzj9exj4obigao2detnr899m2nyjo8j2968ak67qlb25y0kee8';
      nlMessage = 'Sunt de acord cu <a href="/politica-de-confidentialitate/" target="_blank">politica de confidențialitate</a>&nbsp;și confirm că am peste 16 ani.';
      break;
    case 'wbg':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlSignupIdTerm = 'se20-webform-149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlMessage = 'Súhlasím s <a href="/uzitocne-informacie/podmienky-ochrany-osobnych-udajov/" target="_blank">podmienkami ochrany osobných údajov</a>&nbsp;a zároveň potvrdzujem, že mám viac ako 16 rokov.';
      break;
    case 'whr':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlSignupIdTerm = 'se20-webform-149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlMessage = 'Slažem se s <a href="/uzitocne-informacie/podmienky-ochrany-osobnych-udajov/" target="_blank">uvjetima zaštite osobnih podataka</a>&nbsp;i istovremeno potvrđujem da imam više od 16 godina.';
      break;
    case 'wsi':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlSignupIdTerm = 'se20-webform-149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlMessage = 'Strinjam se s <a href="/uzitocne-informacie/podmienky-ochrany-osobnych-udajov/" target="_blank">pogoji politike zasebnosti in potrjujem, da sem starejši/a od 16 let.';
      break;
    case 'wua':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlSignupIdTerm = 'se20-webform-149206-u7vmj9etn951dib3l3e7nj5fyo1rhqnaftuqolbnz9p50h6aufdw0qss3fv332527d60a9bh5e5b2wyn521ndfb1v5crubue0shp';
      nlMessage = 'Súhlasím s <a href="/uzitocne-informacie/podmienky-ochrany-osobnych-udajov/" target="_blank">podmienkami ochrany osobných údajov</a>&nbsp;a zároveň potvrdzujem, že mám viac ako 16 rokov.';
      break;
    case 'dpc':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-bxland000rbq41rusw5b83hu16i5o0ppxdawubwyznvjneckcvbctgilai30kmsu6y958n0xsasl9cqz9q6w0pebrlsczkihmjm0';
      nlSignupIdTerm = 'se20-webform-149206-bxland000rbq41rusw5b83hu16i5o0ppxdawubwyznvjneckcvbctgilai30kmsu6y958n0xsasl9cqz9q6w0pebrlsczkihmjm0';
      nlMessage = 'Súhlasím s <a href="/uzitocne-informacie/podmienky-ochrany-osobnych-udajov/" target="_blank">podmienkami ochrany osobných údajov</a>&nbsp;a zároveň potvrdzujem, že mám viac ako 16 rokov.';
      break;
    case 'mee':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-eswo5wn87mwk75lk4yq4ajq0ja00uibhoq2b548f4hzj8uba0727xscsvakc8uxy47lvl8l33h1o0hc30xl4t26flow4g6460rad';
      nlSignupIdTerm = 'se20-webform-149206-eswo5wn87mwk75lk4yq4ajq0ja00uibhoq2b548f4hzj8uba0727xscsvakc8uxy47lvl8l33h1o0hc30xl4t26flow4g6460rad';
      nlMessage = 'Elfogadom <a href="/hasznos-informaciokat/a-szemelyes-adatok-vedelmenek-feltetelei/" target="_blank">az adatvédelmi szabályzat feltételeit</a>,&nbsp;és egyben megerősítem, hogy elmúltam 16 éves.';
      break;
    case 'jam':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-h90eikjjyjaac56w4pk5x2bar2cswuixn2sqrk7ar6cqyeygv8u6t1ujk19fvus0wsnuf2voklaygr3dyf4mnx5ighdgjnhsav4r';
      nlSignupIdTerm = 'se20-webform-149206-h90eikjjyjaac56w4pk5x2bar2cswuixn2sqrk7ar6cqyeygv8u6t1ujk19fvus0wsnuf2voklaygr3dyf4mnx5ighdgjnhsav4r';
      nlMessage = 'Súhlasím s <a href="/uzitocne-informacie/podmienky-ochrany-osobnych-udajov/" target="_blank">podmienkami ochrany osobných údajov</a>&nbsp;a zároveň potvrdzujem, že mám viac ako 16 rokov.';
      break;
    case 'eag':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-auz7uljx3fitau100wlg9hylrw6moj8yy463u7l4s2dtkqyvqvdq2qcjekyyeqqeppg721543btptq8rzbrngj72bm6tiuyvoem9';
      nlSignupIdTerm = 'se20-webform-149206-auz7uljx3fitau100wlg9hylrw6moj8yy463u7l4s2dtkqyvqvdq2qcjekyyeqqeppg721543btptq8rzbrngj72bm6tiuyvoem9';
      nlMessage = 'Elfogadom <a href="/hasznos-informaciokat/a-szemelyes-adatok-vedelmenek-feltetelei/" target="_blank">az adatvédelmi szabályzat feltételeit</a>,&nbsp;és egyben megerősítem, hogy elmúltam 16 éves.';
      break;
      // TODO NL: pre poschodovky vypnut zobrazovanie v administrácii
    case 'pos':
      nlSignupActionTerm = 'https://app.smartemailing.cz/public/web-forms-v2/display-form/149206-4oq54ribt5svst5w6b6upucxxkuxos2571h1knxbld4069ouv6ga0i6p5vvomcrk9xwvcj4vi77ihfd6nb2ni5nz3omjykr70aey';
      nlSignupIdTerm = 'se20-webform-149206-4oq54ribt5svst5w6b6upucxxkuxos2571h1knxbld4069ouv6ga0i6p5vvomcrk9xwvcj4vi77ihfd6nb2ni5nz3omjykr70aey';
      nlMessage = 'Súhlasím s <a href="https://www.wilsondo.sk/uzitocne-informacie/podmienky-ochrany-osobnych-udajov/?utm_source=poschodovky&amp;utm_medium=referral&amp;utm_campaign=external_linking" target="_blank">podmienkami ochrany osobných údajov</a>&nbsp;a zároveň potvrdzujem, že mám viac ako 16 rokov.';
      break;
  }
  var formConfirmNewsletter = `
    <div class="nl-in-template container">
        <form class="nl-signup" method="post" target="_self" action="${nlSignupActionTerm}" id="${nlSignupIdTerm}">
            <h2>${nlHeadText}</h2>
            <p class="description">${nlHeadDescription}</p>
            <ul>
                <li><label for="frm-webFormHtmlRenderer-webFormForm-fields-df_emailaddress">${nlEmailAdressText}&nbsp;<span style="color: #bf2026">*</span></label>
                    <input type="text" name="fields[df_emailaddress]" data-emailaddress="1" id="frm-webFormHtmlRenderer-webFormForm-fields-df_emailaddress" required="" />
                </li>
                <li class="checkbox-info">
                  <label for="frm-webFormHtmlRenderer-webFormForm-fields-cf_${nlWebFormFieldId}">
                    <input type="checkbox" name="fields[cf_${nlWebFormFieldId}]" id="frm-webFormHtmlRenderer-webFormForm-fields-cf_${nlWebFormFieldId}" required data-nette-rules='[{"op":":filled","msg":"${nlMessageNotification}"}]'>
                    ${nlMessage}
                    &nbsp;<span style="color: #bf2026">*</span>
                    <div class="warning-notification">${nlMessageNotification}</div>
                  </label>
	              </li>
            </ul>
            <input class="submitbtn" type="submit" name="_submit" value="${nlConfirmationButton}" />
            <input type="hidden" name="referrer" id="se-ref-field-id" value="" />
            <input type="hidden" name="sessionid" id="se-sessionid-field" value="" />
            <input type="hidden" name="sessionUid" id="se-sessionUid-field" value="" />
            <input type="hidden" name="_do" value="webFormHtmlRenderer-webFormForm-submit" />
            <div class="clearbox">&nbsp;</div>
        </form>
    </div>
  `;

  $(document).on('click', '.submitbtn', function(event) {
    var emailValue = $('#frm-webFormHtmlRenderer-webFormForm-fields-df_emailaddress').val().trim();
    var isCheckboxChecked = $('#frm-webFormHtmlRenderer-webFormForm-fields-cf_' + nlWebFormFieldId).is(':checked');

    // check whether email is filled, checkbox checked and email valid
    if (emailValue !== "" && isCheckboxChecked && !validateEmail(emailValue)) {
        $('div.warning-notification').show().text(nlEmailValidation);
        event.preventDefault();
    }
  });

  // function to validate email format
  function validateEmail(email) {
    var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  $(document).on('input change', '#frm-webFormHtmlRenderer-webFormForm-fields-df_emailaddress, #frm-webFormHtmlRenderer-webFormForm-fields-cf_' + nlWebFormFieldId, function() {
    var emailValue = $('#frm-webFormHtmlRenderer-webFormForm-fields-df_emailaddress').val().trim();
    var isCheckboxChecked = $('#frm-webFormHtmlRenderer-webFormForm-fields-cf_' + nlWebFormFieldId).is(':checked');
    // check both fields are filled and checked, hide the warning notification
    if (emailValue !== "" && isCheckboxChecked) {
        $('div.warning-notification').hide();
    } else {
        $('div.warning-notification').show();
    }
  });

  if ($('body').hasClass(nlArticleUrl)) {
    $('h1').first().after(formConfirmNewsletter);
  } else {
    $('#footer').before(formConfirmNewsletter);
  }
}